import ActionTypes from '@ziynx/action-types';

const initialState = {};

export default function reduceProfile(state = initialState, action) {
  if (!action.type) {
    return state;
  }

  const talentProfile = state[action?.id] ?? {};

  switch (action.type) {
  case ActionTypes.profile.getResponses.START:
  case ActionTypes.profile.get.START:
  case ActionTypes.profile.patch.START:
  case ActionTypes.profile.putTalentNotes.START:
    return {
      ...state,
      [action?.id]: {
        ...talentProfile,
        fetching: true,
        error: null,
        success: false,
      },
    };

  /* When a profile is viewed, this helps reduce number of dispatches.
  Regardless of success or error. */
  case ActionTypes.trackingAction.viewedProfile.START:
    return {
      ...state,
      [action?.profileViewed]: {
        ...talentProfile,
        viewership: {
          [action?.profileViewed]: true,
        },
      },
    };

  case ActionTypes.profile.get.SUCCESS:
    return {
      ...state,
      [action?.id]: {
        viewership: talentProfile?.viewership ?? {},
        ...(action?.response ?? {}),
        fetching: false,
        error: null,
        success: true,
      },
    };
  case ActionTypes.profile.getResponses.SUCCESS:
    return {
      ...state,
      [action?.id]: {
        ...talentProfile,
        ...(action?.response ?? {}),
        statementResponses:
          (state[action?.id] || {})?.statementResponses.concat(action?.response?.results ?? []),
        statementResponsePagination: {
          page: action?.response?.page,
          isLastPage: action?.response?.isLastPage,
        },
        fetching: false,
        error: null,
        success: true,
      },
    };
  case ActionTypes.profile.patch.SUCCESS:
    return {
      ...state,
      [action?.id]: {
        ...talentProfile,
        ...(action?.response ?? {}),
        fetching: false,
        success: true,
        error: null,
      },
    };
  case ActionTypes.profile.putTalentNotes.SUCCESS:
    return {
      ...state,
      [action?.id]: {
        ...talentProfile,
        ui: {
          ...talentProfile.ui,
          ...(action?.response ?? {}),
        },
        fetching: false,
        success: true,
        error: null,
      },
    };
  // USE ACTION USERINFO _ID FOR ADD/REMOVE ACTIONS
  // INSTEAD OF JUST ACTION?._ID
  case ActionTypes.watchlist.add.START:
  case ActionTypes.watchlist.remove.ERROR:
    return {
      ...state,
      [action?.userInfo?._id]: {
        ...state[action?.userInfo?._id] ?? {},
        ui: {
          watched: true,
        },
      },
    };
  case ActionTypes.watchlist.remove.START:
  case ActionTypes.watchlist.add.ERROR:
    return {
      ...state,
      [action?.userInfo?._id]: {
        ...state[action?.userInfo?._id] ?? {},
        ui: {
          watched: false,
        },
      },
    };
  case ActionTypes.profile.get.ERROR:
  case ActionTypes.profile.patch.ERROR:
  case ActionTypes.profile.getResponses.ERROR:
  case ActionTypes.profile.putTalentNotes.ERROR:
    return {
      ...state,
      [action?.id]: {
        ...talentProfile,
        success: false,
        fetching: false,
        error: action?.error,
      },
    };

  case ActionTypes.watchlist.add.SUCCESS:
  case ActionTypes.watchlist.remove.SUCCESS:
  default:
    return state;
  }
}
